module.exports = __webpack_public_path__ + "static/media/024-honduras.696ff9e2.svg";